import { useReduxState } from 'hooks';
import { EditorBlockTranslationReference } from 'components/editor';
import { EditorBlockTextField } from 'components/editor/blocks';

interface Props {
  initialValue: string;
  optionId: string;
  optionIndex: number;
  referenceValue: string;
  onChange: (id: string, optionIndex: number, newValue: string) => void;
  onFocus: (id: string) => void;
}

const EditorBlockFillinAnswerTranslation = ({
  initialValue,
  optionId,
  optionIndex,
  referenceValue,
  onChange,
  onFocus
}: Props) => {
  const { messages } = useReduxState();

  const handleChange = (value: string) => {
    onChange(optionId, optionIndex, value);
  };

  return (
    <div className="translation-input">
      <EditorBlockTranslationReference
        isInnerElement={true}
        referenceHtml={referenceValue}
        style={{ marginTop: 10, marginBottom: 5 }}
        translationHtml={initialValue || ''}
      >
        <EditorBlockTextField
          onFocus={() => onFocus(optionId)}
          onValueChange={handleChange}
          placeholder={messages.commonAddAnswer}
          style={{ marginBottom: 10 }}
          value={initialValue || ''}
        />
      </EditorBlockTranslationReference>
    </div>
  );
};

export default EditorBlockFillinAnswerTranslation;
